export default __webpack_public_path__ + "static/media/loader-button.a7e673cb.svg";